module.exports = __webpack_public_path__ + "fonts/5c72edf.woff";